import React, { Fragment, useEffect, useState } from 'react';
import {
  DropdownToggle,
  DropdownMenu,
  Button,
  UncontrolledButtonDropdown,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import city3 from '../../../assets/utils/images/dropdown-header/city3.jpg';
import avatar1 from '../../../assets/utils/images/avatars/Meeting.png';
import { Roles } from '../../../constants/Roles';
import Storage from '../../../services/Storage';
import { useDispatch, useSelector } from 'react-redux';
import { ChangePasswordModal } from '../../../Components/CustomModal';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ModalService from '../../../services/ModalService';
import { messages } from '../../../utils/constant-messages';
import { changePassword, getUserInfo } from '../../../constants/apiCalls';
import { handleErrorMessage } from '../../../utils/utils';
import { getPermissionUser, getUserInfoDetail } from '../../../reducers/UserGetReducer';
import { Permissions } from '../../../constants/Permissions';

const UserBox = () => {
  let userInfo = Storage.getUserInfoDetail();
  let tokenInfo = Storage.getTokenDetail();
  let dispatch = useDispatch();

  let userGetInfo = useSelector(state => state.UserGetReducer.userInfoDetail);

  const { permissionArr } = useSelector((state) => state.UserGetReducer);
  let permissions = permissionArr;

  const initState = { currentPswd: '', newPswd: '', confirmPswd: '', isDeviceLogout: false }
  const [data, setData] = useState(initState);
  const [pswdModal, setPswdModal] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  useEffect(() => {
    if (userGetInfo && userGetInfo.is_password_changed === false) {
      setPswdModal(true);
    }
  }, [userGetInfo])


  // let permissions = Storage.getUserPermissionDetail();

  const handleLogOut = () => {
    Storage.clearLocalStorage();
    Storage.clearSessionStorage();
    window.location.href = '/';
  };

  const handlePassword = () => {
    setData(initState);
    setPswdModal(true);
  }



  const handleChangePswd = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setData((prevData) => ({
        ...prevData,
        [name]: checked,
      }));
    } else {
      setData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  }

  const handlePasswordSubmit = (e) => {
    e.preventDefault();

    let { currentPswd, newPswd, confirmPswd, isDeviceLogout } = data;
    if (newPswd !== confirmPswd) {
      ModalService.openAlert('', messages.COMMON.NEW_CONFIRM_PASSWORD_MATCH_ERROR, 'error');
      return;
    }
    let payload = {};
    if (isDeviceLogout === true) {
      payload = {
        current_password: currentPswd,
        new_password: newPswd,
        // confirmPswd: confirmPswd,
        logout_from_other: isDeviceLogout,
        accessToken: tokenInfo && tokenInfo.accessToken ? tokenInfo.accessToken : '',
        refreshToken: tokenInfo && tokenInfo.refreshToken ? tokenInfo.refreshToken : '',
      }
    } else {
      payload = {
        current_password: currentPswd,
        new_password: newPswd,
        // confirmPswd: confirmPswd,
        // isDeviceLogout: isDeviceLogout
      }
    }
    if (payload) {
      setIsModalLoading(true);
      changePassword((res) => {
        const { success, error, message } = res;
        if (success === true) {
          getUserInfo((res) => {
            const { data, success } = res;
            if (success === true) {
              dispatch(getUserInfoDetail(data));
              dispatch(getPermissionUser(data.permissions));

            } else if (success === false || success === 'undefined') {
              ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
            }
          });

          ModalService.openAlert('', message, 'success');
          setPswdModal(false);
          setIsModalLoading(false);
        } else if (success === false || success === 'undefined') {
          setIsModalLoading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsModalLoading(false);
      }, payload);
    }
  }

  return (
    <Fragment>
      <div className="header-btn-lg pr-0">
        <div className="widget-content p-0">
          <div className="widget-content-wrapper">
            <div className="widget-content-left">
              <UncontrolledButtonDropdown>
                <DropdownToggle
                  color="link"
                  className="p-0 d-flex align-items-center border rounded p-1 text-decoration-none mr-lg-0 mr-3"
                >
                  <img
                    width={30}
                    className="rounded-circle mr-2"
                    src={avatar1}
                    alt=""
                  />
                  <div className="text-left mr-2">
                    <span className="font-weight-bold">
                      {userInfo.first_name} {userInfo.last_name}
                    </span>
                    <br />
                    <span>
                      {(userInfo.role === Roles.TM_NAME &&
                        'Territory Manager') ||
                        (userInfo.role === Roles.SH_NAME && 'State Head') ||
                        (userInfo.role === Roles.NH_NAME && 'National Head') ||
                        (userInfo.role === Roles.BH_NAME &&
                          !permissions.includes(Permissions.ADMIN_USER) &&
                          'Business Head') ||
                        (userInfo.role === Roles.BH_NAME &&
                          permissions.includes(Permissions.ADMIN_USER) &&
                          'Admin') ||
                        (permissions.includes(Permissions.CNF_DASHBOARD) && 'CNF User')}
                    </span>
                  </div>
                  <FontAwesomeIcon className="opacity-8" icon={faAngleDown} />
                </DropdownToggle>
                <DropdownMenu end className="rm-pointers dropdown-menu-lg">
                  <div className="dropdown-menu-header">
                    <div className="dropdown-menu-header-inner bg-info">
                      <div
                        className="menu-header-image opacity-2"
                        style={{
                          backgroundImage: 'url(' + city3 + ')',
                        }}
                      />
                      <div className="menu-header-content text-left">
                        <div className="widget-content p-0">
                          <div className="widget-content-wrapper">
                            <div className="widget-content-left mr-3">
                              <img
                                width={42}
                                className="rounded-circle"
                                src={
                                  userInfo.image == null
                                    ? avatar1
                                    : userInfo.image
                                }
                                alt=""
                              />
                            </div>
                            <div className="widget-content-left">
                              <div className="widget-heading">
                                {userInfo.first_name} {userInfo.last_name}
                              </div>
                              <div className="widget-subheading opacity-8">
                                {userInfo.business_name}
                              </div>
                            </div>
                            <div className="widget-content-right mr-2">
                              <Button
                                onClick={handleLogOut}
                                className='btn-pill btn-shadow btn-shine mb-2'
                                color='focus'
                              >
                                Logout
                              </Button>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    // className="scroll-area-xs" 
                    style={{
                      // height: '150px'
                    }}
                  >
                    <PerfectScrollbar>
                      <Nav vertical>
                        <NavItem>
                          <NavLink
                            className='cursorPointer passwordLink'
                            onClick={handlePassword}
                          >
                            Change Password
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </PerfectScrollbar>
                  </div>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
          </div>
        </div>

        <ChangePasswordModal
          isOpen={pswdModal}
          toggle={() => setPswdModal(!pswdModal)}
          isModalLoading={isModalLoading}
          // pswdModal={pswdModal}
          // setPswdModal={setPswdModal}
          data={data}
          handleChangePswd={handleChangePswd}
          handlePasswordSubmit={handlePasswordSubmit}
        />
      </div>
    </Fragment>
  );
};

export default UserBox;
